export const GET_WEATHER = "GET_WEATHER";
export const GET_FORECAST = "GET_FORECAST";
export const GET_WEATHER_AND_FORECAST = "GET_WEATHER_AND_FORECAST";


// WEBPACK FOOTER //
// ./src/js/constants.js